// extracted by mini-css-extract-plugin
export var big = "headline-proxy-module--big--3d3dc";
export var black = "headline-proxy-module--black--922b2";
export var center = "headline-proxy-module--center--301ce";
export var centerMobile = "headline-proxy-module--centerMobile--11cce";
export var centerTablet = "headline-proxy-module--centerTablet--a3176";
export var centerUnderline = "headline-proxy-module--centerUnderline--4fbfb";
export var centerUnderlineMobile = "headline-proxy-module--centerUnderlineMobile--5fe84";
export var grey = "headline-proxy-module--grey--7b774";
export var h1 = "headline-proxy-module--h1--7d551";
export var h2 = "headline-proxy-module--h2--c4519";
export var h3 = "headline-proxy-module--h3--4e8d8";
export var h4 = "headline-proxy-module--h4--7822a";
export var newStyle = "headline-proxy-module--newStyle--8b423";
export var primary = "headline-proxy-module--primary--3a73c";
export var secondary = "headline-proxy-module--secondary--3bb27";
export var underline = "headline-proxy-module--underline--871eb";
export var white = "headline-proxy-module--white--72dca";